module.exports = __webpack_public_path__ + "static/media/asrr.3bf4eed3.svg";